export enum RegraFrequencia {
    DIARIA = "Diaria",
    SEMANAL = "Semanal",
    QUINZENAL = "Quinzenal",
    MENSAL = "Mensal",
    NENHUMA = "Nenhuma"
}
